import { PURE_SOULS_URL, IMG } from "@/lib/site";

/**
 * Compact featured provider card for use on Home + Find a Provider pages.
 * Variant 'inline' for homepage; 'full' for directory page.
 */
export default function FeaturedProviderCard({ variant = "inline" }) {
  if (variant === "full") {
    return (
      <article
        className="grid grid-cols-1 md:grid-cols-12 gap-0 bg-water-200 rounded-3xl overflow-hidden border border-water-300/60 shadow-card transition-all duration-500 ease-out hover:shadow-lift hover:-translate-y-1"
        data-testid="featured-provider-full"
      >
        <div className="md:col-span-5 relative min-h-[300px]">
          <img
            src={IMG.dogGrass}
            alt="A dog gazing out over the Australian coast at sunset"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-water-200/45" />
        </div>
        <div className="md:col-span-7 p-10 lg:p-14 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="text-xs font-semibold uppercase tracking-[0.22em] text-water-700 font-sans">
                Featured Provider
              </span>
              <span className="inline-flex items-center text-[10px] font-semibold tracking-[0.22em] uppercase text-water-800 bg-white/60 border border-water-300 px-3 py-1 rounded-full">
                Queensland · Premium
              </span>
            </div>
            <h3 className="font-serif text-3xl sm:text-4xl text-forest-900 tracking-tight leading-tight mb-3">
              Pure Souls Pet Aqua Cremation
            </h3>
            <p className="text-forest-800 leading-relaxed mb-6">
              Premium pet water cremation services based in Townsville,
              Queensland, focused on compassionate care, sustainability, and
              meaningful memorial experiences for families.
            </p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2 mb-8 text-sm text-forest-800">
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-clay-500" /> Individual aqua cremation
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-clay-500" /> Personalised memorials
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-clay-500" /> Compassionate transfer
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-clay-500" /> Identification & tracking
              </li>
            </ul>
          </div>
          <a
            href={PURE_SOULS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary self-start"
            data-testid="featured-provider-visit-button"
          >
            Visit Pure Souls →
          </a>
        </div>
      </article>
    );
  }

  // Inline homepage variant
  return (
    <div
      className="glass-panel rounded-2xl px-8 py-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 transition-all duration-500 ease-out hover:shadow-lift hover:-translate-y-1"
      data-testid="featured-provider-inline"
    >
      <div className="flex items-start gap-5">
        <span className="inline-flex h-12 w-12 rounded-full bg-water-500/12 items-center justify-center border border-water-200">
          <span className="block h-2 w-2 rounded-full bg-water-600" />
        </span>
        <div>
          <p className="overline mb-1">Featured Australian Provider</p>
          <h3 className="font-serif text-2xl text-forest-900 leading-tight">
            Pure Souls Pet Aqua Cremation
          </h3>
          <p className="text-sm text-forest-700 mt-1 max-w-md leading-relaxed">
            Premium pet water cremation services based in Townsville, Queensland, focused on compassionate care, sustainability, and meaningful memorial experiences.
          </p>
        </div>
      </div>
      <a
        href={PURE_SOULS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-secondary whitespace-nowrap"
        data-testid="featured-provider-link"
      >
        Learn More →
      </a>
    </div>
  );
}
